import React, { useEffect, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Sample partner data - replace with your actual partners
const partners = [
  { id: 1, name: 'Cross Point', logo: 'assets/images/suppliers/crosspoint.png' },
  { id: 2, name: 'Lead Tech', logo: 'assets/images/suppliers/leadtech.png' },
  { id: 3, name: 'Savema', logo: 'assets/images/suppliers/savema.png' },
  { id: 4, name: 'Dibal', logo: 'assets/images/suppliers/dibal.jpg'},
  { id: 5, name: 'Honeywell', logo: 'assets/images/suppliers/honeywell.png' },
  { id: 6, name: 'Zebra', logo: 'assets/images/suppliers/zebra.png' },
  { id: 7, name: 'Rongta', logo: 'assets/images/suppliers/rongta.png' },
  { id: 8, name: 'Zar-TIJ', logo: 'assets/images/suppliers/zartij.jpg' },
  { id: 9, name: 'Sunmi', logo: 'assets/images/suppliers/sunmi.png' },
];

export default function PartnersMarquee() {
  const scrollRef = useRef(null);
  const [animationSpeed, setAnimationSpeed] = useState(1);

  // Function to handle marquee animation
  useEffect(() => {
    const marqueeElement = scrollRef.current;
    if (!marqueeElement) return;

    let scrollAmount = 0;
    let scrollDirection = 1;
    
    const animate = () => {
      scrollAmount += 0.5 * animationSpeed * scrollDirection;
      marqueeElement.style.transform = `translateX(${-scrollAmount}px)`;
      
      // Check if we need to reset the scroll position
      const maxScroll = marqueeElement.scrollWidth / 2;
      if (scrollAmount >= maxScroll) {
        scrollAmount = 0;
      }
      
      requestAnimationFrame(animate);
    };
    
    const animationId = requestAnimationFrame(animate);
    
    return () => cancelAnimationFrame(animationId);
  }, [animationSpeed]);

  // Double the partners for seamless infinite scrolling
  const doubledPartners = [...partners, ...partners];

  return (
    <div className="container my-5">
        <div className="section-header text-center mb-5">
          <h6 className=" text-uppercase font-weight-bold" style={{color:"#006672"}}>Our Trusted Partners</h6>
          <h3 className=" fw-bold">The Brands Behind Us</h3>
          <div className="divider mx-auto my-4"></div>
        </div>
      
      <div className="">
        <div className=" p-0">
          <div className="overflow-hidden position-relative" style={{ height: '100px' }}>
            <div className="d-flex align-items-center position-absolute" ref={scrollRef}>
              {doubledPartners.map((partner, index) => (
                <div key={`${partner.id}-${index}`} className="mx-4 d-flex flex-column align-items-center">
                  <img 
                    src={partner.logo} 
                    alt={`${partner.name} logo`} 
                    className="img-fluid mt-2" 
                    style={{ maxHeight: '50px'}}
                  />
                  <span className="mt-2 text-center fw-bold text-nowrap" style={{minWidth:"140px",  fontFamily:"Poppins"}}></span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* <div className="mt-4">
        <label htmlFor="speedControl" className="form-label">Animation Speed</label>
        <input 
          type="range" 
          className="form-range" 
          id="speedControl" 
          min="0.5" 
          max="3" 
          step="0.5" 
          value={animationSpeed}
          onChange={(e) => setAnimationSpeed(parseFloat(e.target.value))}
        />
        <div className="d-flex justify-content-between">
          <small>Slow</small>
          <small>Fast</small>
        </div>
      </div> */}
    </div>
  );
}